import { api } from '@/shared/api/client-api'
import { API_END_POINTS } from '@/shared/api/end-points'
import { ProjectCaseResponse } from '../../lib'
import { GetProjectCaseParams } from '@/shared/api/end-points/project'

const getprojectcase = async (dto: GetProjectCaseParams) => {
  return await api.json<ProjectCaseResponse>(API_END_POINTS.project.getProjectCase(dto))
}

export default getprojectcase
